import { Typography } from '@mui/material';
import Decimal from 'decimal.js';
import React from 'react';
import useCurrencyDisplay from '../pages/Checkout/useCurrencyDisplay';
import { useAppSelector } from '../redux/hooks';
import { selectAdminSettings } from '../redux/selectors/checkoutSelectors';

interface CurrencyTextProps {
  value: number | Decimal;
  saleValue?: number | Decimal;
  salePercentage?: number;
  decimalsToShow?: number;
}

export default function CurrencyText({
  value,
  saleValue,
  salePercentage,
  decimalsToShow,
}: Readonly<CurrencyTextProps>) {
  const { format } = useCurrencyDisplay();
  const adminSettings = useAppSelector(selectAdminSettings);

  if (
    !salePercentage &&
    adminSettings.isVisualDiscountEnabled &&
    adminSettings.visualDiscountPercentage
  ) {
    salePercentage = adminSettings.visualDiscountPercentage;
  }

  if (salePercentage) {
    saleValue = new Decimal(value).mul(1 - salePercentage / 100);
  }

  const showSale = saleValue && (typeof saleValue === 'number' || !saleValue.isZero());

  return (
    <Typography variant="inherit" component={'span'}>
      {showSale && (
        <Typography variant="inherit" component={'span'} sx={{ textDecoration: 'line-through' }}>
          {format(value, decimalsToShow)}
        </Typography>
      )}
      {showSale && (
        <Typography variant="inherit" component={'span'}>
          {' '}
        </Typography>
      )}
      <Typography variant="inherit" component={'span'}>
        {format(saleValue || value, decimalsToShow)}{' '}
      </Typography>
    </Typography>
  );
}
